export default {"src":"/_next/static/media/metamask.913378c8.svg","height":13,"width":16,"blurWidth":0,"blurHeight":0};